import { create } from 'zustand';

import type { StrikeActionKey } from '@shared/risk.js';
import { getMyStrikes } from '../api/safetyApi';

interface StrikesState {
  strikeCount: number;
  lastStrikeAt: string | null;
  lastActionTaken: StrikeActionKey | null;
  isBanned: boolean;
  bannedUntil: string | null;
  hydrated: boolean;
  hydrate: () => Promise<void>;
  hydrateFromMe: (input: {
    strikes_count: number;
    is_banned: boolean;
    banned_until: string | null;
  }) => void;
}

export const useStrikesStore = create<StrikesState>((set) => ({
  strikeCount: 0,
  lastStrikeAt: null,
  lastActionTaken: null,
  isBanned: false,
  bannedUntil: null,
  hydrated: false,
  hydrate: async () => {
    try {
      const data = await getMyStrikes();
      set({
        strikeCount: data.strike_count,
        lastStrikeAt: data.last_strike_at,
        lastActionTaken: data.last_action_taken,
        isBanned: data.is_banned,
        bannedUntil: data.banned_until,
        hydrated: true,
      });
    } catch {
      // silent
    }
  },
  hydrateFromMe: (input) => {
    set({
      strikeCount: input.strikes_count,
      isBanned: input.is_banned,
      bannedUntil: input.banned_until,
      hydrated: true,
    });
  },
}));
